import { render } from "./FolderNavigationActions.vue?vue&type=template&id=6dc784a0&scoped=true"
import script from "./FolderNavigationActions.vue?vue&type=script&lang=js"
export * from "./FolderNavigationActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc784a0"]])

export default __exports__